<template>
  <sButton
    v-if="can_createAuction"
    data-qa="btn-create-auction"
    :loading="loading"
    @click="createAuction">
    {{ $t(`Tenders.CreateAuction`) }}
  </sButton>
</template>
<script>

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'createFrameAuction',
  data() {
    return {
      loading: false
    }
  },
  props: {
    tender: Object
  },
  computed: {
    can_createAuction() {
      let status = this.tender?.tenderStatus?.id
      return status == this.statuseKeys.COMPLETED && this.$acl.check('onlyTenders') && !this.tender.hasRoute && this.tender.biddingType.isFrameFirstStage
    }
  },
  methods: {
    createAuction() {
      this.loading = true
      api.createFrameAuction({
        tenderId: this.tender.tenderId,
        biddingTypeId: 98,
        organizationItId: +this.$route.params.org
      })
        .then(res => {
          this.$router.push({
            name: 'editTender',
            query: {step: 1, id: res},
            params: { org: this.$route.params.org}
          })
        })
        .finally(() => this.loading = false)
    }
  }
}
</script>
